import styled from 'styled-components';

export const RootContainer = styled.main`
  height: 100dvh;
  width: 100dvw;
  display: flex;
  flex-direction: column;
`;
